import { render, staticRenderFns } from "./ProjectRegister.vue?vue&type=template&id=0dba2cfe&scoped=true&"
import script from "./ProjectRegister.vue?vue&type=script&lang=js&"
export * from "./ProjectRegister.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRegister.vue?vue&type=style&index=0&id=0dba2cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dba2cfe",
  null
  
)

export default component.exports